import { isRequired, combineValidators, composeValidators } from "revalidate";

export const monthOptions = [
  { key: "Enero", value: "01", text: "Enero" },
  { key: "Febrero", value: "02", text: "Febrero" },
  { key: "Marzo", value: "03", text: "Marzo" },
  { key: "Abril", value: "04", text: "Abril" },
  { key: "Mayo", value: "05", text: "Mayo" },
  { key: "Junio", value: "06", text: "Junio" },
  { key: "Julio", value: "07", text: "Julio" },
  { key: "Agosto", value: "08", text: "Agosto" },
  { key: "Septiembre", value: "09", text: "Septiembre" },
  { key: "Octubre", value: "10", text: "Octubre" },
  { key: "Noviembre", value: "11", text: "Noviembre" },
  { key: "Diciembre", value: "12", text: "Diciembre" },
];

export const getClientOptions = (clients) => {
  if (!clients) return [];

  return clients?.map((client) => ({
    key: client.id,
    value: `${client.id}%${client.companyID}`,
    text: client.name,
  }));
};

let yearOptions;
export const getYearOptions = () => {
  if (yearOptions) return yearOptions;

  const currentYear = new Date().getFullYear();
  yearOptions = Array.from(
    { length: currentYear - 2019 },
    (_, index) => currentYear - index
  ).map((year) => ({
    key: year,
    value: year,
    text: year,
  }));

  return yearOptions;
};

export const getMonthOptions = (isEnabled, year, fromMonth = '01') => {
  if (!isEnabled || !year) return [];

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  let lastMonth = 12;

  if (year === currentYear) {
    lastMonth = currentMonth;
  }

  return monthOptions.filter((month) => (Number(fromMonth) <= Number(month.value) && Number(month.value) <= lastMonth));
};

export const exportReport = (report, reportInfo) => {
    const url = window.URL.createObjectURL(new Blob([report], { type: 'application/csv' }));

    const link = document.createElement('a');

    link.download = `${reportInfo.tenantCompanyId}_${reportInfo.year}-${reportInfo.monthFrom}-${reportInfo.monthTo}.csv`;
    link.href = url;
    link.style.display = 'none';
    link.click();


    link.remove();
    window.URL.revokeObjectURL(url);
};

export const validateForm = combineValidators({
    client: composeValidators(
      isRequired({ message: "El cliente es requerido" }),
    )(),
    yearReports: composeValidators(
      isRequired({ message: "El año es requerido" }),
    )(),
    startMonthReports: composeValidators(
      isRequired({ message: "El mes de inicio es requerido" }),
    )(),
    endMonthReports: composeValidators(
      isRequired({ message: "El mes de fin es requerido" }),
    )(),
});
